const textAnimation = function() { 
   // Wrap every letter in a span
    const textWrapper = document.querySelectorAll('.ml16');
    textWrapper.forEach(element => element.innerHTML = element.textContent.replace(/\S/g, "<span class='letter'>$&</span>"));

    anime.timeline({loop: true})
    .add({
        targets: '.ml16 .letter',
        opacity: [0,1],
        easing: "easeInOutQuad",
        duration: 2250,
        delay: (el, i) => 100 * (i+1)
    }).add({
        targets: '.ml16',
        opacity: 0,
        duration: 1000,
        easing: "easeOutExpo",
        delay: 1000
    });

    // Div display by the right with scroll
    if (document.querySelector('.to-the-left')) {
        const elementsToTheLeft = document.querySelectorAll('.to-the-left');
        elementsToTheLeft.forEach(function(element) {
            window.onscroll = function () {
                if (!element.classList.contains('show') && (window.pageYOffset + window.innerHeight) > element.offsetTop) {
                    element.classList.add('show');
                }
            }
        });
    }
}

addFunctionOnWindowLoad(textAnimation);